var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNaturalLightExposureActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_10838_9577)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 7,
    fill: "currentColor",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 1,
    r: 1,
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 19.7783,
    cy: 4.22085,
    r: 1,
    transform: "rotate(45 19.7783 4.22085)",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 4.22183,
    cy: 4.22266,
    r: 1,
    transform: "rotate(-45 4.22183 4.22266)",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 23,
    cy: 12,
    r: 1,
    transform: "rotate(90 23 12)",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 23,
    r: 1,
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 4.22168,
    cy: 19.7775,
    r: 1,
    transform: "rotate(45 4.22168 19.7775)",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 19.7785,
    cy: 19.7773,
    r: 1,
    transform: "rotate(-45 19.7785 19.7773)",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1,
    cy: 12,
    r: 1,
    transform: "rotate(90 1 12)",
    fill: "currentColor"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_10838_9577"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNaturalLightExposureActive);
export default __webpack_public_path__ + "static/media/natural-light-exposure-active.e681a3f09ff952170969f4f3a0ebbc44.svg";
export { ForwardRef as ReactComponent };